import React from "react";
import PropTypes from "prop-types";
import FieldLabel from "../../components/label";
import OtpInput from "../../components/otp";
import { withStyles } from "@mui/styles";
import { Box, Button } from "@mui/material";
import { useStyles } from "./indexStyles";
import { FORM_FIELD_OTP } from "../../constants/field";

const LoginOtp = ({
  classes: { formGroup },
  errors = [],
  form,
  handleChangeMobile,
  onSubmitGenerateOtp,
  setFormState,
}) => {
  return (
    <>
      <Box className={formGroup} pt={0}>
        <FieldLabel label={"OTP*"} />
        <OtpInput
          changeNumber={true}
          onChangeNumberClick={() => {}}
          otp={form[FORM_FIELD_OTP]}
          otpCallBack={(otp) => setFormState(FORM_FIELD_OTP, otp)}
          resendOtp={onSubmitGenerateOtp}
          disabled={false}
          errors={errors}
          buttonText={"Resend OTP"}
        />
      </Box>

      {1 === 2 && (
        <Box
          mt={0}
          display={"flex"}
          justifyContent={"center"}
          width={"100%"}
          alignItems={"center"}
        >
          <Box className={formGroup} sx={{ width: "85%" }}>
            <Button
              variant="outlined"
              size="small"
              color="secondary"
              onClick={handleChangeMobile}
              disabled={false}
              fullWidth
            >
              Change Mobile
            </Button>
          </Box>
        </Box>
      )}
    </>
  );
};

LoginOtp.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(useStyles, { withTheme: true })(LoginOtp);
